import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

interface ArticleCardProps {
  id: string;
  title: string;
  excerpt: string;
  category: string;
  date: string;
  readTime: string;
  imageUrl: string;
}

export default function ArticleCard({ id, title, excerpt, category, date, readTime, imageUrl }: ArticleCardProps) {
  const cat = categories.find((c) => c.slug === category);
  const catColor = cat?.color === 'accent'
    ? { bg: 'bg-accent-100', text: 'text-accent-800' }
    : { bg: 'bg-primary-100', text: 'text-primary-800' };

  return (
    <Link
      to={`/article/${id}`}
      className="group block bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300"
    >
      <div className="aspect-[16/9] overflow-hidden bg-background-100">
        <img
          src={imageUrl}
          alt={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="p-5">
        <div className="flex items-center gap-3 mb-3">
          <span className={`inline-block px-2.5 py-0.5 rounded-full text-xs font-medium ${catColor.bg} ${catColor.text}`}>
            {cat?.name}
          </span>
          <span className="text-xs text-foreground-400">{date}</span>
          <span className="text-xs text-foreground-400">{readTime}</span>
        </div>
        <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
          {title}
        </h3>
        <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
          {excerpt}
        </p>
      </div>
    </Link>
  );
}